module.exports = __webpack_public_path__ + "static/grilled-cheese-49bcfe21e58f8b84bdeabd362e94f7c4.ttf";